/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：955
 */

"use strict"

var r = require(/* 533 */"../1724/533")
var o = require(/* 194 */"../1648/194")
var i = require(/* 168 */"../1648/168")
var a = require(/* 1089 */"../1774/1089")
module.exports = r || !i(function () {
  if (!(a && a < 535)) {
    var e = Math.random()
    __defineSetter__.call(null, e, function () {})
    delete o[e]
  }
})
